import {
    CATEGORY_LIST_PAGE_LOADED,
    CATEGORY_LIST_PAGE_UNLOADED,
    CATEGORY_DETAIL_PAGE_LOADED,
    CATEGORY_DETAIL_PAGE_UNLOADED,
    CATEGORY_UPDATE_LOADED,
    CATEGORY_UPDATE_UNLOADED,
    CATEGORY_UPDATE,
    CATEGORY_DELETE
} from '../constants/actionTypes'
export default (state = {}, action) => {
    switch (action.type) {
        case CATEGORY_LIST_PAGE_LOADED:
            return {
                ...state,
                categories: action.payload.categories,
            }
        case CATEGORY_LIST_PAGE_UNLOADED:
        case CATEGORY_DETAIL_PAGE_UNLOADED:
        case CATEGORY_UPDATE_UNLOADED:
            return {}
        case CATEGORY_DETAIL_PAGE_LOADED:
            return {
                ...state,
                category: action.payload[0].category,
                products: action.payload[1].products,
                logs: action.payload[2].logs,
            }
        case CATEGORY_UPDATE_LOADED:
            return {
                ...state,
                category: action.payload.category,
            }
        case CATEGORY_UPDATE:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.error : null,
                updated: action.error ? false : true
            };
        case CATEGORY_DELETE:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.error : null,
                removed: action.error ? false : true
            };
        default:
            return state
    }
};



// WEBPACK FOOTER //
// ./src/reducers/category.js